import request from '@/utils/request'

// 按订单号查询易收宝银行交易状态(银行已成功本地未落账时自动补单)
// 注意:后端 c_service 注册为 POST,这里必须用 post,否则报"调用方式不对"
export function queryNbcbOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.queryNbcbOrder',
      method: 'post',
      data: params,
      showLoading: false
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '查询易收宝订单失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
